import * as React from 'react';

export interface SwitchProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onCheckedChange?: (checked: boolean) => void;
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className = '', checked, onCheckedChange, onChange, ...props }, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(event);
      onCheckedChange?.(event.target.checked);
    };

    // `primary` is a numbered scale here with no bare shade, so `bg-primary`
    // compiles to nothing: until 2026-10-04 an "on" switch stayed gray and
    // only the knob moved.
    return (
      <label className="relative inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          className="sr-only peer"
          ref={ref}
          checked={checked}
          onChange={handleChange}
          {...props}
        />
        <div
          className={`
            peer h-6 w-11 rounded-full bg-gray-200 
            after:absolute after:left-[2px] after:top-[2px] 
            after:h-5 after:w-5 after:rounded-full 
            after:border after:border-gray-300 after:bg-white 
            after:transition-all after:content-[''] 
            peer-checked:bg-primary-600 
            peer-checked:after:translate-x-full 
            peer-checked:after:border-white 
            peer-focus:outline-none peer-focus:ring-4 
            peer-focus:ring-primary-500/20 
            dark:border-gray-600 dark:bg-gray-700 
            ${className}
          `}
        />
      </label>
    );
  }
);
Switch.displayName = 'Switch';

export { Switch };
